import { ElectronApi } from 'APP/packages/electron/ElectronApi';

export function focusApp(): void {
  if (ElectronApi.isEnabled) {
    ElectronApi.focusApp();
  } else {
    window.focus();
  }
}
